import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=07bf1b65&scoped=true"
import script from "./handle.vue?vue&type=script&lang=js"
export * from "./handle.vue?vue&type=script&lang=js"
import style0 from "./handle.vue?vue&type=style&index=0&id=07bf1b65&prod&lang=css"
import style1 from "./handle.vue?vue&type=style&index=1&id=07bf1b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf1b65",
  null
  
)

export default component.exports